export const VARIANT_CONFIG = {
  default: {
    strokeColor: '#00000040',
    backgroundColor: '#fafafa',
    borderColor: '#d9d9d9',
    title: 'Is your package attractive?',
    subtitle:
      'Add discounts to your room and experiences to save and be listed on Staycation.',
    items: [],
  },
  green: {
    strokeColor: '#28A745',
    backgroundColor: '#F4FBF6',
    borderColor: '#C8E6D1',
    title: 'Great Attractiveness',
    subtitle:
      'Your package is set at the right price and positioned to maximise visibility.',
    items: [],
  },
  gold: {
    strokeColor: '#FA8C16',
    backgroundColor: '#FFF7E6',
    borderColor: '#FFD591',
    title: 'Average Attractiveness',
    subtitle: 'Your package shows potential, but has room to perform better.',
    items: [
      'Increase discount on your Rooms',
      'Increase discount on your Activities',
    ],
  },
  red: {
    strokeColor: '#F5222D',
    backgroundColor: '#FFF1F0',
    borderColor: '#FFA39E',
    title: 'Weak Attractiveness',
    subtitle: `Your package may struggle to attract bookings. Consider improving your offer.`,
    items: [
      'Increase discount on your Rooms',
      'Increase discount on your Activities',
    ],
  },
};

const SCORE_THRESHOLDS: {
  max: number;
  variant: keyof typeof VARIANT_CONFIG;
}[] = [
  { max: 49, variant: 'red' },
  { max: 59, variant: 'gold' },
  { max: 100, variant: 'green' },
];

export const getVariantFromScore = (
  score: number | undefined
): keyof typeof VARIANT_CONFIG => {
  if (score === undefined) {
    return 'default';
  }

  const validScore = Math.round(score);
  const threshold = SCORE_THRESHOLDS.find(({ max }) => validScore <= max);

  return threshold?.variant ?? 'default';
};
